import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { useNavigate, useParams } from "react-router-dom";
import {
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import {
  GET_HEAD_OFFICE_BY_PARTNER_ID,
  SEARCH_BRANCHES,
  UPDATE_BRANCHES,
} from "../../../constants/graphql/branch-queries";
import { useDispatch, useSelector } from "react-redux";
import {
  getBranchProfile,
  getPartnerList,
  handleOnChangeReducer,
} from "../../../features/branches/edit-branches-slice";
import { PARTNERS } from "../../../constants/graphql/partner-agent-queries";
import {
  Tooltip,
  Breadcrumbs,
  Button,
  Checkbox,
  Modal,
  Select,
  Textarea,
  Textfield,
} from "../../../components/core";
import { setSearchDataReducer } from "../../../features/branches/search-branches-slice";
import { PatternFormat } from "react-number-format";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
const breadcrumbItems = [
  {
    label: "Branches",
    path: `/branches/`,
  },
  { label: "Branch Profile", path: "#" },
];

function areRequiredFieldsEmptyOrNull(obj) {
  const requiredFields = [
    "operatorId",
    "partnerBranch",
    "contactPerson",
    "contactPerson2",
    "zipCode",
    "mobile",
    "mobile2",
    "email",
    "email2",
    "branchStatus",
  ];

  for (const key of requiredFields) {
    if (obj[key] === null || obj[key] === "") {
      return true; // At least one required field is empty or null
    }
  }
  return false; // All required fields are filled
}

export default function BranchProfile() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const [landlineAreaCode, setLandlineAreaCode] = useState("");
  const [landline1, setlandline1] = useState("");
  const [landlineAreaCode2, setLandlineAreaCode2] = useState("");
  const [landline2, setLandline2] = useState("");
  const [changesMade, setChangesMade] = useState(false);
  const [validationErrors, setvalidationErrors] = React.useState({
    partnerBranch: false,
    address: false,
    zipCode: false,
    contactPerson: false,
    contactPerson2: false,
    mobile: false,
    mobile2: false,
    email: false,
    email2: false,
  });

  // * Utilities
  const client = useApolloClient();
  const { partnerBranchId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // * redux variables and states
  const branchProfile = useSelector(
    (state) => state.branchProfile.branchProfile
  );
  const partnerList = useSelector((state) => state.branchProfile.partnerList);

  // * apollo client queries and mutations
  const searchBranches = useQuery(SEARCH_BRANCHES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerBranchId: partnerBranchId,
    },
  });
  const [getHeadOfficeByPartnerId] = useLazyQuery(
    GET_HEAD_OFFICE_BY_PARTNER_ID
  );
  const getHeadOfficeByPartnerIdSingle = useQuery(
    GET_HEAD_OFFICE_BY_PARTNER_ID,
    { variables: { partnerId: branchProfile.partnerId } }
  );
  const partners = useQuery(PARTNERS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const [updateBranches] = useMutation(UPDATE_BRANCHES);

  //* local states
  const [snack, setSnack] = React.useState({
    isOpen: false,
    message: "",
    type: "success",
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    submessage: "Confirm this change?",
    open: false,
  });

  const [editingFlag, setEditingFlag] = useState(false);
  const [successValidation, setSuccessValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    submessage: "Confirm this change?",
    open: false,
  });
  const [openSaveModal, setOpenSaveModal] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [isHeadOffice, setIsHeadOffice] = React.useState(false);

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  React.useEffect(() => {
    if (branchProfile.landline != null) {
      if (branchProfile.landline.length > 2) {
        if (branchProfile.landline.includes("*")) {
          setLandlineAreaCode(branchProfile.landline.toString().split("*")[0]);
          setlandline1(branchProfile.landline.toString().split("*")[1]);
        } else {
          setLandlineAreaCode(
            branchProfile.landline.toString().substring(0, 2)
          );
          setlandline1(branchProfile.landline.toString().substring(2));
        }
      } else {
        setLandlineAreaCode(branchProfile.landline);
      }
    }
    if (branchProfile.landline2 != null) {
      if (branchProfile.landline2.length > 2) {
        if (branchProfile.landline2.includes("*")) {
          setLandlineAreaCode2(
            branchProfile.landline2.toString().split("*")[0]
          );
          setLandline2(branchProfile.landline2.toString().split("*")[1]);
        } else {
          setLandlineAreaCode2(
            branchProfile.landline2.toString().substring(0, 2)
          );
          setLandline2(branchProfile.landline2.toString().substring(2));
        }
      } else {
        setLandlineAreaCode2(branchProfile.landline2);
      }
    }
  }, [branchProfile.landline]);
  const handleCancelChanges = () => {
    setEditingFlag(false);
    searchBranches
      .refetch({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        partnerBranchId: partnerBranchId,
      })
      .then((data) => {
        if (data.data) {
          let branchProfileData = data.data.searchBranches[0];
          let tempVar = {
            branchLevel: branchProfileData.branchLevel,
            partnerId: branchProfileData.partner.partnerId,
            partnerBranchId: branchProfileData.partnerBranchId,
            partnerBranch: branchProfileData.partnerBranch,
            address: branchProfileData.address,
            contactPerson: branchProfileData.contactPerson,
            contactPerson2: branchProfileData.contactPerson2,
            contactPosition: branchProfileData.contactPosition,
            contactPosition2: branchProfileData.contactPosition2,
            landline: landlineAreaCode + landline1,
            landline2: landlineAreaCode2 + landlineAreaCode2,
            mobile: branchProfileData.mobile,
            mobile2: branchProfileData.mobile2,
            email: branchProfileData.email,
            email2: branchProfileData.email2,
            zipCode: branchProfileData.zipCode,
            remarks: branchProfileData.remarks,
            branchStatus: branchProfileData.branchStatus,
            statusComments: branchProfileData.statusComments,
            loadBalance: branchProfileData.loadBalance,
          };
          dispatch(getBranchProfile(tempVar));
        }
        setOpenCancelModal(false);
        // setSuccessValidation({
        // 	icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        // 	title: "Success",
        // 	message: "Operation Canceled.",
        // 	open: true,
        // });
        window.location.reload();
      });
  };

  const handleSaveChanges = () => {
    console.log("Here");
    let tempProfile = {
      ...branchProfile,
    }; // Create a new object using the spread operator
    tempProfile.mobile = "63" + tempProfile.mobile;
    tempProfile.mobile2 = "63" + tempProfile.mobile2;
    tempProfile.landline = landlineAreaCode + "*" + landline1;
    tempProfile.landline2 = landlineAreaCode2 + "*" + landline2;
    tempProfile.operatorId = JSON.parse(
      localStorage.getItem("user")
    ).operator_id;
    tempProfile.partnerBranchId = partnerBranchId;
    delete tempProfile.partnerId;
    ///
    console.log("Here1");
    if (areRequiredFieldsEmptyOrNull(tempProfile)) {
      setSuccessValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid entry",
        message: "Please fill all required fields.",
        open: true,
      });
      console.log("Here2");
    } else {
      console.log("Here3");
      // client.clearStore();
      let arrEntry = [];
      getHeadOfficeByPartnerId({
        variables: { partnerId: branchProfile.partnerId },
      }).then((data) => {
        if (
          parseInt(
            data.data.getHeadOfficeByPartnerId[0].partner.partnerBranchId
          ) !== parseInt(branchProfile.partnerBranchId) &&
          tempProfile.branchLevel === 0
        ) {
          let tempObj = {
            operatorId: localStorage.getItem("user")
              ? JSON.parse(localStorage.getItem("user")).operator_id
              : "",
            branchLevel: 1,
            // partnerId: data.data.getHeadOfficeByPartnerId[0].partner.partnerId,
            partnerBranchId:
              data.data.getHeadOfficeByPartnerId[0].partnerBranchId,
            partnerBranch: data.data.getHeadOfficeByPartnerId[0].partnerBranch,
            address: "",
            contactPerson: data.data.getHeadOfficeByPartnerId[0].contactPerson,
            contactPerson2:
              data.data.getHeadOfficeByPartnerId[0].contactPerson2,
            contactPosition:
              data.data.getHeadOfficeByPartnerId[0].contactPosition,
            contactPosition2:
              data.data.getHeadOfficeByPartnerId[0].contactPosition2,
            landline: landlineAreaCode + "*" + landline1,
            landline2: landlineAreaCode2 + "*" + landline2,
            mobile: "63" + data.data.getHeadOfficeByPartnerId[0].mobile,
            mobile2: "63" + data.data.getHeadOfficeByPartnerId[0].mobile2,
            email: data.data.getHeadOfficeByPartnerId[0].email,
            email2: data.data.getHeadOfficeByPartnerId[0].email2,
            zipCode: data.data.getHeadOfficeByPartnerId[0].zipCode,
            remarks: data.data.getHeadOfficeByPartnerId[0].remarks,
            branchStatus: data.data.getHeadOfficeByPartnerId[0].branchStatus,
            statusComments:
              data.data.getHeadOfficeByPartnerId[0].statusComments,
            loadBalance: data.data.getHeadOfficeByPartnerId[0].loadBalance,
          };
          arrEntry.push(tempObj);
        }
        // arrEntry[0] = tempProfile;
        arrEntry.push(tempProfile);
        console.log(arrEntry);
        console.log("Here4");
        updateBranches({ variables: { branches: arrEntry } })
          .then((data) => {
            if (data.data) {
              let branchProfileData =
                data.data.updatePartnerBranch.partnerBranch;
              console.log({ branchProfileData });
              let tempVar = {
                branchLevel: branchProfileData.branchLevel,
                partnerId: branchProfileData.partner.partnerId,
                partnerBranchId: branchProfileData.partnerBranchId,
                partnerBranch: branchProfileData.partnerBranch,
                address: branchProfileData.address,
                contactPerson: branchProfileData.contactPerson,
                contactPerson2: branchProfileData.contactPerson2,
                contactPosition: branchProfileData.contactPosition,
                contactPosition2: branchProfileData.contactPosition2,
                landline: landlineAreaCode + "*" + landline1,
                landline2: landlineAreaCode2 + "*" + landlineAreaCode2,
                mobile: branchProfileData.mobile.substring(2),
                mobile2: branchProfileData.mobile2.substring(2),
                email: branchProfileData.email,
                email2: branchProfileData.email2,
                zipCode: branchProfileData.zipCode,
                remarks: branchProfileData.remarks,
                branchStatus: branchProfileData.branchStatus,
                statusComments: branchProfileData.statusComments,
                loadBalance: branchProfileData.loadBalance,
              };
              dispatch(getBranchProfile(tempVar));
              dispatch(setSearchDataReducer([]));
              client.clearStore();
            }
            setSuccessValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
              title: "Success",
              message: "Successfully modified this branch profile.",
              open: true,
            });
          })
          .catch((e) => {
            setSuccessValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: "Invalid operation",
              message:
                "Please check your entry if there is duplication of Branch or check your internet connection.",
              open: true,
            });
          });
        console.log("Here5");
      });
    }
    // Log the updated object
    setOpenSaveModal(false);
  };

  const handleOnChange = (event) => {
    setEditingFlag(true);
    setChangesMade(true);
    const { name, value, checked } = event.target;
    if (name === "branchLevel" && checked === true) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Assign as Head Office",
        message: `You are assigning ${
          branchProfile.partnerBranch
        } as a head office. Your current head office ${
          getHeadOfficeByPartnerIdSingle.data &&
          getHeadOfficeByPartnerIdSingle.data.getHeadOfficeByPartnerId[0]
            .partnerBranch
        } will be assigned as a sub branch`,
        submessage: "Confirm this change?",
        open: true,
      });
      // setChangesMade(false);

      return;
    } else {
      dispatch(
        handleOnChangeReducer({ name: name, value: value, checked: checked })
      );
    }
  };
  React.useEffect(() => {
    if (getHeadOfficeByPartnerIdSingle.data) {
      if (
        getHeadOfficeByPartnerIdSingle.data.getHeadOfficeByPartnerId[0]
          .partnerBranchId === partnerBranchId
      ) {
        setIsHeadOffice(true);
      }
    }
  }, [getHeadOfficeByPartnerIdSingle.data]);
  React.useEffect(() => {
    if (searchBranches.data) {
      let branchProfileData = searchBranches.data.searchBranches[0];
      let tempVar = {
        branchLevel: branchProfileData.branchLevel,
        partnerId: branchProfileData.partner.partnerId,
        partnerBranchId: branchProfileData.partnerBranchId,
        partnerBranch: branchProfileData.partnerBranch,
        address: branchProfileData.address,
        contactPerson: branchProfileData.contactPerson,
        contactPerson2: branchProfileData.contactPerson2,
        contactPosition: branchProfileData.contactPosition,
        contactPosition2: branchProfileData.contactPosition2,
        landline: branchProfileData.landline,
        landline2: branchProfileData.landline2,
        mobile: branchProfileData.mobile.substring(2),
        mobile2: branchProfileData.mobile2.substring(2),
        email: branchProfileData.email,
        email2: branchProfileData.email2,
        zipCode: branchProfileData.zipCode,
        remarks: branchProfileData.remarks,
        branchStatus: branchProfileData.branchStatus,
        statusComments: branchProfileData.statusComments,
        loadBalance: branchProfileData.loadBalance,
      };
      dispatch(getBranchProfile(tempVar));
    }
  }, [searchBranches.data]);
  React.useEffect(() => {
    if (partners.data) {
      let tempVar = [];
      partners.data.partners.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      dispatch(getPartnerList(tempVar));
    }
  }, [partners.data]);

  const [callOnce, setCallOnce] = React.useState(false);

  var beforeBranch = !callOnce ? branchProfile.partnerBranch : "";
  React.useEffect(() => {
    setCallOnce(true);
  }, [callOnce]);
  React.useEffect(() => {}, [branchProfile.branchLevel]);
  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer
        containerTitle={`${beforeBranch} BRANCH PROFILE ${
          !branchProfile.branchLevel ? "(Head Office)" : ""
        }`}
      >
        <>
          <div className="w-full grid grid-cols-5 gap-x-2 gap-y-2 pr-2 mb-[20px]">
            <div className="w-full grid grid-cols-3 gap-x-2 pr-2 col-span-5">
              <div className="w-full">
                <div className="flex flex-row mb-[40px]">
                  <p className="my-auto mr-2">Branch level:</p>
                  <div className="flex">
                    <Checkbox
                      disabled={
                        isHeadOffice ||
                        accessPermission.branches === 1 ||
                        accessPermission.branches === "1"
                      }
                      label="Head office"
                      onChange={handleOnChange}
                      checked={branchProfile.branchLevel === 0 ? true : false}
                      name="branchLevel"
                    />
                    {isHeadOffice && <Tooltip />}
                  </div>
                </div>

                <div className="flex flex-row">
                  <p className="my-auto mr-2">Partner:</p>
                  <p className="font-bold">
                    {partnerList.find(
                      (x) => x.value === branchProfile.partnerId
                    ) &&
                      partnerList.find(
                        (x) => x.value === branchProfile.partnerId
                      ).name}
                  </p>
                </div>
              </div>
              <div></div>
              {/* <div className="w-full grid grid-cols-2 gap-2 pl-2 h-1/2 pr-4">
								<p className="my-auto">Change Current Status to:</p>
								<Select
									name="branchStatus"
									value={branchProfile.branchStatus.toString()}
									items={[
										{ value: 0, name: "Suspended" },
										{ value: 1, name: "Active" },
									]}
									defaultOption={{ value: -1, name: "-- Select Status --" }}
									onChange={handleOnChange}
									disabled={
										accessPermission.branches === 1 ||
										accessPermission.branches === "1"
									}
								/>
								<p className="my-auto">Reason for Status Change:</p>
								<Textarea
									maxLength={1000}
									name="statusComments"
									value={branchProfile.statusComments}
									onChange={handleOnChange}
									disabled={
										accessPermission.branches === 1 ||
										accessPermission.branches === "1"
									}
								/>
							</div> */}
            </div>
            <div>
              <i className="text-red-500">*</i>Branch Name:
            </div>
            <div className="col-span-3">
              <Textfield
                classNameParent={" flex flex-row"}
                className={`${
                  validationErrors.partnerBranch ? "border-red-500" : ""
                } w-full`}
                type="text"
                name="partnerBranch"
                maxLength={32}
                value={branchProfile.partnerBranch}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.partnerBranch == true
                      ? "This field is required"
                      : " "}
                  </p>
                }
              />
            </div>

            <div className="col-span-1"></div>
            {/* Leave the location for now, it's to be fixed */}
            {/* <p className="my-auto flex">
							<p className="text-red-500">*</p>Country:
						</p>
						<Select disabled={true} />
						<div className="col-span-3"></div>

						<p className="my-auto flex">
							<p className="text-red-500">*</p>Region:
						</p>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<p className="my-auto flex">
							<p className="text-red-500">*</p>Province:
						</p>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<p className="my-auto flex">
							<p className="text-red-500">*</p>City/District:
						</p>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<p className="my-auto flex">
							<p className="text-red-500">*</p>Barangay:
						</p>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<p className="my-auto flex">
							<p className="text-red-500">*</p>Address:
						</p>

						<div className="col-span-2 mt-[20px]">
							<Textarea
								name="address"
								maxLength={96}
								value={branchProfile.address}
								onChange={handleOnChange}
								disabled={
									accessPermission.branches === 1 ||
									accessPermission.branches === "1"
								}
								classNameInside={`${validationErrors.address ? " border border-red-500" : ""}`}
								error={
									<p className="text-red-800 my-auto italic">
										{validationErrors.address == true
											? "This field is required"
											: ""}
									</p>
								}
							/>
						</div>
						<div className="col-span-2"></div>

						<p className="my-auto flex">
							<p className="text-red-500">*</p>ZIP Code:
						</p>
						<Textfield
							type={"text"}
							maxLength={4}
							name="zipCode"
							value={branchProfile.zipCode}
							onChange={(e) => {
								if (/^\d*$/.test(e.target.value)
								) { handleOnChange(e) }
							}}
							disabled={
								accessPermission.branches === 1 ||
								accessPermission.branches === "1"
							}
							className={`${validationErrors.zipCode ? "border-red-500" : ""} w-full`}
							error={
								<p className="text-red-800 my-auto italic w-full">
									{validationErrors.zipCode
										? "This field is required (4 digits)"
										: ""}
								</p>
							}
						/> */}
          </div>

          <hr className="col-span-3 my-2"></hr>
          <p className="font-bold col-span-3 text-lg">CONTACT PEOPLE</p>
          {/* Contacts Person */}
          <div className="col-span-5 grid grid-cols-5 gap-2 my-2 bg-secondary-buttonGray py-4 px-2">
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Contact Person 1:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.contactPerson ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.contactPerson
                      ? "This field is required"
                      : ""}
                  </p>
                }
                name="contactPerson"
                maxLength={32}
                value={branchProfile.contactPerson}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>

            <p className="my-auto">Position:</p>
            <div className="col-span-2">
              <Textfield
                className="w-1/2"
                name="contactPosition"
                value={branchProfile.contactPosition}
                maxLength={32}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>

            <p className="my-auto flex">
              <p className="text-red-500">*</p>Mobile Number:
            </p>
            <div className="col-span-2 flex flex-row items-center justify-start">
              <p className="mr-[5px]">+63</p>
              <Textfield
                className={`${
                  validationErrors.mobile ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.mobile
                      ? "This field is required (9XXXXXXXXX)"
                      : ""}
                  </p>
                }
                name="mobile"
                maxLength={10}
                value={branchProfile.mobile}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <div className="flex flex-row justify-between w-full items-center">
              <p className="ml-2">Landline:</p>
              <div className="col-span-2">
                <Textfield
                  placeholder={"(02)"}
                  className={`w-[50px] text-center`}
                  autocomplete="off"
                  name={"landline"}
                  onChange={(e) => {
                    setLandlineAreaCode(e.target.value);
                    setEditingFlag(true);
                  }}
                  value={landlineAreaCode}
                  maxLength={3}
                />
              </div>
            </div>
            <PatternFormat
              valueIsNumericString
              format="########"
              mask=""
              name="landline"
              placeholder="XXXXXXXXX"
              onChange={(e) => {
                setlandline1(e.target.value);
                setEditingFlag(true);
              }}
              value={landline1}
              customInput={Textfield}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
            />
            <div className="col-span-3"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Email Address:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.email ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.email
                      ? "This field is required (e.g. account@mbox.com)"
                      : ""}
                  </p>
                }
                name="email"
                maxLength={64}
                value={branchProfile.email}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          <div className="col-span-5 grid grid-cols-5 gap-2 my-2 bg-secondary-buttonGray py-4 px-2">
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Contact Person 2:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.contactPerson2 ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.contactPerson2
                      ? "This field is required"
                      : ""}
                  </p>
                }
                name="contactPerson2"
                maxLength={32}
                value={branchProfile.contactPerson2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <p className="my-auto">Position:</p>
            <div className="col-span-2">
              <Textfield
                className="w-1/2"
                name="contactPosition2"
                value={branchProfile.contactPosition2}
                onChange={handleOnChange}
                maxLength={32}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Mobile Number:
            </p>
            <div className="col-span-2 flex flex-row items-center justify-start">
              <p className="mr-[5px]">+63</p>
              <Textfield
                className={`${
                  validationErrors.mobile2 ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.mobile2
                      ? "This field is required (9XXXXXXXXX)"
                      : ""}
                  </p>
                }
                name="mobile2"
                maxLength={10}
                value={branchProfile.mobile2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>{" "}
            <div className="col-span-2"></div>
            <div className="flex flex-row justify-between w-full items-center">
              <p className="ml-2">Landline:</p>
              <Textfield
                placeholder={"(02)"}
                className={`w-[50px] text-center`}
                autocomplete="off"
                name={"landline2"}
                onChange={(e) => {
                  setLandlineAreaCode2(e.target.value);
                  setEditingFlag(true);
                }}
                value={landlineAreaCode2}
                maxLength={3}
              />
            </div>
            <PatternFormat
              valueIsNumericString
              format="########"
              mask=""
              name="landline2"
              placeholder="XXXXXXXXX"
              onChange={(e) => {
                setLandline2(e.target.value);
                setEditingFlag(true);
              }}
              value={landline2}
              customInput={Textfield}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
            />
            <div className="col-span-3"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Email Address:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.email2 ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.email2
                      ? "This field is required (e.g. account@mbox.com)"
                      : ""}
                  </p>
                }
                name="email2"
                maxLength={64}
                value={branchProfile.email2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          {/* ID's and other checkboxes */}
          <div className="grid grid-cols-5 mt-2 gap-y-4">
            <p className="my-auto">Remarks:</p>
            <div className="col-span-2">
              <Textarea
                name="remarks"
                maxLength={1000}
                value={branchProfile.remarks}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          <div
            className={`mt-[30px] grid grid-cols-2 gap-2 w-1/3 ${
              editingFlag ? "" : "hidden"
            }`}
          >
            <Button
              value={"Cancel"}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
              className={"p-2"}
              onClick={() => setOpenCancelModal(true)}
            />
            <Button
              value={"Save Changes"}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
              className={"p-2"}
              onClick={() => {
                setvalidationErrors({
                  partnerBranch: false,
                  address: false,
                  zipCode: false,
                  contactPerson: false,
                  contactPerson2: false,
                  mobile: false,
                  mobile2: false,
                  email: false,
                  email2: false,
                });

                var thereIsError = false;
                ///Validate here
                console.log(branchProfile);
                if (branchProfile.partnerBranch.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    partnerBranch: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "1");
                }
                // if (branchProfile.address.toString() == "") {
                // 	setvalidationErrors((prevErrors) => ({
                // 		...prevErrors,
                // 		address: true,
                // 	}));
                // 	thereIsError = true;

                // 	console.log(thereIsError + "2");
                // }
                if (branchProfile.zipCode.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    zipCode: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "3");
                }
                if (branchProfile.contactPerson.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    contactPerson: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "4");
                }
                if (!/^9\d{9}$/.test(branchProfile.mobile.toString())) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    mobile: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "5");
                }
                if (
                  !/^(?:\d{3}-\d{4}|\d{2}-\d{4}|(?:\+?63|\+?09)\d{9})$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                    branchProfile.email.toString()
                  )
                ) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    email: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "6");
                }
                if (branchProfile.contactPerson2.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    contactPerson2: true,
                  }));
                  thereIsError = true;

                  console.log(thereIsError + "7");
                }
                if (!/^9\d{9}$/.test(branchProfile.mobile2.toString())) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    mobile2: true,
                  }));
                  thereIsError = true;
                  console.log(thereIsError + "8");
                }
                if (
                  !/^(?:\d{3}-\d{4}|\d{2}-\d{4}|(?:\+?63|\+?09)\d{9})$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                    branchProfile.email2.toString()
                  )
                ) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    email2: true,
                  }));
                  thereIsError = true;
                  console.log(thereIsError + "9");
                }
                if (thereIsError) {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setOpenSaveModal(false);
                  return;
                }
                setOpenSaveModal(true);
              }}
            />
          </div>

          <Modal
            icon={`${process.env.PUBLIC_URL}/assets/images/check.png`}
            title="Save Changes"
            message="Are you sure you want to save all changes?"
            open={openSaveModal}
            actions={
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => setOpenSaveModal(false)}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={handleSaveChanges}
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            }
          />
          <Modal
            icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
            title="Cancel Changes"
            message="Are you sure you want to cancel all changes?"
            open={openCancelModal}
            actions={
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => {
                    setOpenCancelModal(false);
                    setActiveSubItem(activeSubItem);
                    setPendingNavigation(null);
                  }}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={() => {
                    if (pendingNavigation) {
                      navigate(pendingNavigation);
                      setPendingNavigation(null);
                      setChangesMade(false);
                      // handleCancelChanges();
                    } else {
                      handleCancelChanges();
                    }
                  }}
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            }
          />
          <Modal
            icon={successValidation.icon}
            title={successValidation.title}
            message={successValidation.message}
            submessage={successValidation.submessage}
            open={successValidation.open}
            className="w-1/3"
            actions={
              <div className="grid grid-cols-1 gap-2 mt-2">
                <Button
                  onClick={() => {
                    setSuccessValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            }
          />
          {/* Modal for head office validations */}
          <Modal
            icon={validation.icon}
            title={validation.title}
            message={validation.message}
            submessage={validation.submessage}
            open={validation.open}
            className="w-1/3"
            actions={
              <div className="grid grid-cols-2 gap-2 mt-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                    dispatch(
                      handleOnChangeReducer({
                        name: "branchLevel",
                        checked: false,
                      })
                    );
                  }}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={() => {
                    setValidation({
                      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                      title: "Invalid data",
                      message: "",
                      open: false,
                    });
                    dispatch(
                      handleOnChangeReducer({
                        name: "branchLevel",
                        checked: true,
                      })
                    );
                  }}
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            }
          />
        </>
      </ContentContainer>
    </div>
  );
}
